export { AreaComponent, AreaComponentSkeleton } from './AreaComponent';
